import React from 'react';
import { Box } from '@mui/material';
import SlSkeleton from 'src/components/BeaconV2Components/SlSkeleton/SlSkeleton';
import { LibraryTableHeader } from './LibraryTableHeader';
import colors from 'src/utils/colors';

const SkeletonRow: React.FC<{ isFirst: boolean; isLast: boolean }> = ({ isFirst, isLast }) => {
  const getBorderRadius = () => {
    if (isFirst && isLast) return '8px';
    if (isFirst) return '8px 8px 0 0';
    if (isLast) return '0 0 8px 8px';
    return '0';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '60px',
        padding: '0 16px',
        border: `1px solid ${colors.graysSecondary}`,
        borderTop: isFirst ? `1px solid ${colors.graysSecondary}` : '0',
        borderRadius: getBorderRadius(),
        backgroundColor: 'white',
        gap: '64px'
      }}
    >
      {/* Product Column */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', width: '429px' }}>
        <SlSkeleton variant="rectangular" width={30} height={30} sx={{ borderRadius: '4px', flexShrink: 0 }} />
        <SlSkeleton variant="text" width="70%" height={20} />
      </Box>

      {/* Retailer SKU Column */}
      <Box sx={{ width: '94px' }}>
        <SlSkeleton variant="text" width="80%" height={20} />
      </Box>

      {/* Last Updated By Column */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', width: '189px' }}>
        <SlSkeleton variant="circular" width={30} height={30} sx={{ flexShrink: 0 }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
          <SlSkeleton variant="text" width="80%" height={16} />
          <SlSkeleton variant="text" width="60%" height={14} />
        </Box>
      </Box>

      {/* Versions Column */}
      <Box sx={{ flex: 1 }}>
        <SlSkeleton variant="text" width={20} height={20} />
      </Box>

      {/* Arrow Column */}
      <Box sx={{ width: '24px', display: 'flex', justifyContent: 'center' }}>
        <SlSkeleton variant="circular" width={16} height={16} />
      </Box>
    </Box>
  );
};

export const LibraryLoadingState: React.FC = () => {
  const rowCount = 5;

  return (
    <Box sx={{ WebkitFontSmoothing: 'antialiased' }}>
      <LibraryTableHeader />
      {/* Loading Skeleton Rows */}
      <Box>
        {Array.from({ length: rowCount }).map((_, index) => (
          <SkeletonRow 
            key={index} 
            isFirst={index === 0} 
            isLast={index === rowCount - 1} 
          />
        ))}
      </Box>
    </Box>
  );
};
